var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape-star",
    clipPath: "url(#clip0_33292_803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4301 5.694L10.7094 5.008L8.60076 0.733336C8.53945 0.629241 8.45204 0.542952 8.34716 0.483002C8.24228 0.423052 8.12356 0.391518 8.00276 0.391518C7.88195 0.391518 7.76324 0.423052 7.65836 0.483002C7.55348 0.542952 7.46606 0.629241 7.40476 0.733336L5.29209 5.008L0.571426 5.694C0.448319 5.71177 0.332639 5.76363 0.237463 5.84371C0.142287 5.92378 0.0714116 6.02889 0.0328492 6.14714C-0.00571322 6.2654 -0.0104244 6.39208 0.0192482 6.51287C0.0489209 6.63366 0.111794 6.74375 0.200759 6.83067L3.61743 10.16L2.81143 14.862C2.79042 14.9846 2.80413 15.1106 2.85101 15.2259C2.89789 15.3411 2.97607 15.4409 3.07671 15.514C3.17735 15.5871 3.29643 15.6306 3.4205 15.6395C3.54456 15.6485 3.66866 15.6226 3.77876 15.5647L8.00076 13.3453L12.2228 15.5647C12.3329 15.6226 12.457 15.6485 12.581 15.6395C12.7051 15.6306 12.8242 15.5871 12.9248 15.514C13.0254 15.4409 13.1036 15.3411 13.1505 15.2259C13.1974 15.1106 13.2111 14.9846 13.1901 14.862L12.3841 10.16L15.8008 6.83067C15.8897 6.74383 15.9526 6.63386 15.9823 6.51316C16.0121 6.39247 16.0075 6.26587 15.9691 6.14765C15.9306 6.02943 15.8599 5.9243 15.7649 5.84414C15.6699 5.76398 15.5544 5.71198 15.4314 5.694H15.4301Z",
    fill: "#FCD420"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33292_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.9df8cb320c872f1167ac3c1d7f53eb24.svg";
export { ForwardRef as ReactComponent };